export default {
  namespaced: true,
  actions: {
    async handleError({commit, rootGetters}, payload) {
      const error = payload.error
      const logging = payload.logging || false

      if (error.response) {
        if (logging) {
          /* Запрос был сделан, и сервер ответил кодом состояния, выпадающим из диапазона 2хх */
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        }

        if (error.response.status === 500) {
          commit('context/SET_MESSAGES', {
            'detail': 'Внутренняя ошибка сервера'
          }, {root: true})
        } else {
          commit('context/SET_MESSAGES', error.response.data, {root: true})
        }
      } else if (error.request) {
        if (logging) {
          /* Запрос сделан, но ответа не получено, `error.request` это экземпляр XMLHttpRequest в браузере */
          console.log(error.request);
        }
        

        commit('context/SET_MESSAGES', {
          'detail': 'Ошибка соединения с сервером. Проверьте соединение с интернетом.'
        }, {root: true})
      } else {
        if (logging) {
          /* Что-то случилось с запросом и вызвало ошибку */
          console.log('Error', error.message);
        }

        commit('context/SET_MESSAGES', {'detail': error.message}, {root: true})
      }

      if (logging) {
        console.log(error);
      }

      if (rootGetters['context/messages'] === null) {
        commit('context/SET_MESSAGES', {
          'detail': 'Неизвестная ошибка. Обратитесь в поддержку: <a href="mailto:abit@kuzstu.ru">abit@kuzstu.ru</a>',
        }, {root: true})
      }
    }
  }
}
